import(/* webpackMode: "eager", webpackExports: ["ArticleAds"] */ "/opt/app/components/article-page/ArticlePageAdvertisements.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsGallery"] */ "/opt/app/components/article-page/GalleryLeadMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsReadEventTracking"] */ "/opt/app/components/common/NewsReadEventTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInButton"] */ "/opt/app/components/common/SignInButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpsellForm"] */ "/opt/app/components/common/upsell-message/UpsellForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpsellLoginBanner"] */ "/opt/app/components/common/upsell-message/UpsellLoginBanner.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/@costar-ui/news/dist/module/custom.css");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/client/link.js");
